module.exports = __webpack_public_path__ + "img/topLogo_w.d9829d68.svg";